module.exports = __webpack_public_path__ + "static/logo-78ab721db551dc38f2be386b4df98bfb.png";